// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/login\"},{\"path\":\"/login/sent\"},{\"path\":\"/me\"},{\"path\":\"/privacy\"},{\"path\":\"/signup/review\"},{\"path\":\"/signup/start\"},{\"path\":\"/signup/step1\"},{\"path\":\"/signup/step1/sent\"},{\"path\":\"/signup/step2\"},{\"path\":\"/signup/step3\"},{\"path\":\"/signup/step4\"},{\"path\":\"/signup/step5\"},{\"path\":\"/signup/step6\"},{\"path\":\"/signup/success\"},{\"path\":\"/verify-email/error\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/_error-reports";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://8f431262f33d62acd61729ca474815b9@o4505767139016704.ingest.us.sentry.io/4508522769416192",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  enabled: (window as any).__E2E_TEST !== "true" && process.env.NODE_ENV === "production",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;